"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWithLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icominds_lib_1 = require("@greatmindsorg/icominds-lib");
var IconWithLabel_styled_1 = require("./IconWithLabel.styled");
var IconWithLabel = function (_a) {
    var name = _a.name, _b = _a.className, className = _b === void 0 ? '' : _b, size = _a.size, label = _a.label, ariaLabel = _a.ariaLabel;
    return ((0, jsx_runtime_1.jsxs)(IconWithLabel_styled_1.StyledIconWithLabel, { children: [(0, jsx_runtime_1.jsx)(icominds_lib_1.Icon, { name: name, className: className, size: size, ariaHidden: false }), (0, jsx_runtime_1.jsx)("span", { className: "visually-hidden", children: ariaLabel }), (0, jsx_runtime_1.jsx)("span", { "aria-hidden": true, children: label })] }));
};
exports.IconWithLabel = IconWithLabel;
exports.default = exports.IconWithLabel;
